define('views/components/product/product',['require','backbone','text!templates/components/product/product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/product/product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'product-item'
    });
});
